(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
function setupAubeProduct(root){
  root.querySelectorAll('[data-gallery]').forEach(gallery=>{
    if(gallery.dataset.ready)return; gallery.dataset.ready='true';
    const buttons=[...gallery.querySelectorAll('.gallery-thumb')],img=gallery.querySelector('.product-main-image');let current=0,startX=null,startY=null;
    const show=i=>{current=(i+buttons.length)%buttons.length;const b=buttons[current];img.src=b.dataset.full;img.srcset=b.dataset.srcset;img.alt=b.dataset.alt;buttons.forEach((x,n)=>x.setAttribute('aria-pressed',String(n===current)));gallery.querySelector('.gallery-count').textContent=`${current+1} / ${buttons.length}`;};
    buttons.forEach((b,i)=>b.addEventListener('click',()=>show(i)));
    gallery.querySelector('[data-gallery-prev]').addEventListener('click',()=>show(current-1));gallery.querySelector('[data-gallery-next]').addEventListener('click',()=>show(current+1));
    gallery.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();show(current+(e.key==='ArrowRight'?1:-1));buttons[current].focus();}});
    const surface=gallery.querySelector('.gallery-main');
    surface.addEventListener('touchstart',e=>{startX=e.touches[0].clientX;startY=e.touches[0].clientY;},{passive:true});
    surface.addEventListener('touchend',e=>{if(startX===null)return;const dx=e.changedTouches[0].clientX-startX,dy=e.changedTouches[0].clientY-startY;if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy))show(current+(dx<0?1:-1));startX=null;},{passive:true});
  });
  root.querySelectorAll('[data-product-section]').forEach(section=>{
    const trigger=section.querySelector('[data-primary-add]'),bar=section.querySelector('[data-mobile-buy]');if(!trigger||section.dataset.ready)return;section.dataset.ready='true';
    const update=()=>{const bounds=trigger.getBoundingClientRect();bar.hidden=bounds.top>=100&&bounds.bottom<=window.innerHeight;};
    new IntersectionObserver(update,{rootMargin:'-100px 0px 0px 0px',threshold:[0,1]}).observe(trigger);update();
  });
}
setupAubeProduct(document);document.addEventListener('shopify:section:load',e=>setupAubeProduct(e.target));

  } catch(e) { console.error(e); }
})();
})();
